import { Dispatch, SetStateAction } from "react";
import { Typography } from "@material-ui/core";
import { ShareLinksList } from "./ShareLinksList";
import { CustomTablePagination } from "../../shared/CustomTablePagination/CustomTablePagination";
import { ShareLink } from "../../../generated/graphql";

interface ShareLinksTableListProps {
  loading: boolean;
  links: Partial<ShareLink>[];
  total: number;
  page: number;
  rowsPerPage: number;
  canManage: boolean;
  onOpenModal: (id: string) => void;
  setPage: Dispatch<SetStateAction<number>>;
  setRowsPerPage: Dispatch<SetStateAction<number>>;
  setNotifications: Dispatch<
    SetStateAction<{ error: boolean; success: boolean; message: string }>
  >;
}

export const ShareLinksTableList = ({
  loading,
  links,
  total,
  page,
  rowsPerPage,
  canManage,
  onOpenModal,
  setPage,
  setRowsPerPage,
  setNotifications,
}: ShareLinksTableListProps) => {
  if (!loading && !links.length) {
    return (
      <Typography
        variant="subtitle1"
        color="textSecondary"
        align="center"
        style={{ margin: "40px" }}
      >
        За вашим запитом нічого не знайдено. Спробуйте змінити параметри пошуку
        або фільтри.
      </Typography>
    );
  }

  return (
    <>
      <ShareLinksList
        links={links}
        canManage={canManage}
        onOpenModal={onOpenModal}
        setNotifications={setNotifications}
      />
      <CustomTablePagination
        rowsPerPageOptions={[10, 20]}
        count={total}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={(_, newPage) => setPage(newPage)}
        onRowsPerPageChange={(e) => {
          setRowsPerPage(+e.target.value);
          setPage(0);
        }}
      />
    </>
  );
};
